import header from "./header";
import info from "./info";
import participantCode from "./participantCode";
import application from "./application";
import companyProfile from "./companyProfile";
import users from "./users";
import passes from "./passes";
import documents from "./documents";
import catalog from "./catalog";
import news from "./news";
import subexponent from "./subexponent";
import organizerControlPanel from "./organizerControlPanel";
import subexpReadNotification from "./subexpReadNotification";
import stands from "./stands";
import changeCompany from "./changeCompany";
import servicesOrder from "./servicesOrder";

export default {
  loading: "Загрузка выставки...",
  error403: "У вас нет доступа к ресурсу",
  servicesTitle: "Услуги на выставке",
  passesTitle: "Оформление пропусков",
  documentsTitle: "Документы и пропуска",

  cardQuota: {
    outof: "{count} из {total}",
    availablePluralize: ["доступного", "доступных", "доступных"],
    passPluralize: ["пропуск", "пропуска", "пропусков"],
    howToIncrease: "Как увеличить квоту"
  },

  managers: {
    title: "Ваши менеджеры",
    description:
      "Если у Вас есть вопросы, обратитесь к одному из менеджеров выставки:",

    titleMontage: "Контакты организаторов",
    titleCatalog: "Менеджер, ответственный за каталог:",
    titleService: "Услуги для экспонентов:",
    serviceBureau: "Сервис Бюро",
    descriptionMontage:
      "Если у Вас есть вопросы, обратитесь к одному из организаторов:"
  },

  header,
  info,
  participantCode,
  application,
  companyProfile,
  users,
  passes,
  documents,
  catalog,
  news,
  subexponent,
  organizerControlPanel,
  subexpReadNotification,
  stands,
  changeCompany,
  servicesOrder
};
